export default {
    es: {
        registerCard: "Registrar tarjeta",
        registerPayment: "Registrar pago de forma segura",
        encryptedMessage: "Tus datos están protegidos y encriptados",
        enterCardDetails: "Ingresa los detalles de tu tarjeta de crédito o débito para realizar el pago.",
        card: "Tarjeta",
        name: "Nombre del cliente",
        cardholder: "Nombre tal como aparece en la tarjeta",
        cardNumber: "Número de tarjeta",
        expiryDate: "Fecha de expiración",
        cvv: "Código de seguridad",
        month: "Mes",
        year: "Año",
        placeholder: {
            cardholder: "Nombre completo como aparece en la tarjeta",
            cardNumber: "0000 0000 0000 0000",
            cvv: "CVV",
        },
        alt: {
            cardImage: "Imagen de la tarjeta",
        },
        button: {
            save: "Guardar tarjeta",
            pay: "Pagar",
        },
        termsAndConditions: "Términos y condiciones",
        privacyPolicy: "Política de privacidad",
        secure: "Conexión segura",
        detail: {
            title: "Detalles del pago",
        },
        concept: "Concepto",
        subconcept: "Subconcepto",
        validation: {
            "mustBeAtLeast": "debe tener al menos",
            "charactersLong": "caracteres",
            "mustNotExceed": "no debe exceder",
            characters: "caracteres",
            required: "es requerido",
            onlyLetters: "solo puede contener letras y espacios",
            min: "mínimo",
            mustBeNumeric: "debe ser numérico",
            invalidExpirationDate: "Fecha de expiración inválida",
        },
        totalAmount: "Monto total",
        client: "Cliente",
        clientName: "Nombre",
        clientLastName: "Apellido",
        tooltip: {
            cvv: "CVV es el código de 3 dígitos <br /> que se encuentra en la <br /> parte posterior de tu tarjeta.",
            expiryDate: "La fecha de expiración se <br /> encuentra típicamente en la <br /> parte frontal de tu tarjeta, debajo <br /> del número de tarjeta.",
            automaticPaymentDate: "Fecha de inicio del cobro automático mensual.",
        },
        successMessages: {
            success: "Éxito",
            cardRegistered: "Tarjeta registrada exitosamente",
            completedForm: "Tu pago ha sido procesado con éxito. Puedes cerrar esta ventana.",
            paymentSuccess: "Pago exitoso",
        },
        errorMessages: {
            error: "Error",
            genericError: "Ocurrió un error, por favor intenta nuevamente.",
            cardNotRegistered: "No se pudo registrar la tarjeta",
            cardInvalid: "Tarjeta inválida",
            linkInvalid: "Enlace inválido",
            cardNotVerified: "No se pudo verificar la tarjeta. Probablemente no tiene fondos suficientes.",
            cardAlreadyRegistered: "La tarjeta ya ha sido registrada",
            paymentFailed: "Pago fallido",
        },
        invalidLink: "Enlace inválido",
        invalidLinkDescription: "El enlace que buscas ha expirado o ya no está disponible.",
        validLink: "Operación realizada con éxito",
        validLinkDescription: "La operación se ha completado con éxito. Puedes cerrar esta ventana.",
        validLinkDescriptionWithErrors: "La operación se ha completado con errores. Puedes cerrar esta ventana.",
        initialPayment: "Pago inicial",
        monthlyPayment: "Pago mensual",
        transactionDeclined: "Transacción declinada",
        automaticPayment: "Pago programado",
        automaticPaymentAmount: "Monto",
        automaticPaymentDay: "Seleccione día de pago",
        amount: "Monto",
        status: "Estado",
        service: "Servicio",
        concept: "Concepto",
        datetime: "Fecha/Hora",
        transactionId: "ID Transacción",
        scheduledPaymentDate: "Fecha de siguiente pago",
        monthlyPaymentAmount: "Monto de pago mensual",
        date: "Fecha",
        service: "Servicio",
        configureAutomaticPayment: "Programar pago automático",
        save: "Guardar",
        close: "Cerrar",
    },
    en: {
        registerCard: "Register card",
        registerPayment: "Register payment securely",
        encryptedMessage: "Your data is protected and encrypted.",
        enterCardDetails: "Enter your credit or debit card details to make the payment.",
        card: "Card",
        name: "Client name",
        cardholder: "Name as it appears on the card",
        cardNumber: "Card number",
        expiryDate: "Expiration date",
        cvv: "Security code",
        month: "Month",
        year: "Year",
        placeholder: {
            cardholder: "Full name as it appears on the card",
            cardNumber: "0000 0000 0000 0000",
            cvv: "CVV",
        },
        alt: {
            cardImage: "Card image",
        },
        button: {
            save: "Save card",
            pay: "Pay",
        },
        termsAndConditions: "Terms and conditions",
        privacyPolicy: "Privacy policy",
        secure: "Secure connection",
        detail: {
            title: "Payment details",
        },
        concept: "Concept",
        subconcept: "Subconcept",

        validation: {
            mustBeAtLeast: "must be at least",
            charactersLong: "characters long",
            mustNotExceed: "must not exceed",
            characters: "characters",
            required: "is required",
            onlyLetters: "can only contain letters and spaces",
            min: "min",
            mustBeNumeric: "must be numeric",
            invalidExpirationDate: "Invalid expiration date",
        },
        totalAmount: "Total amount",
        client: "Client",
        clientName: "Name",
        clientLastName: "Last name",
        tooltip: {
            cvv: "CVV is the 3-digit code <br /> found on the <br /> back of your card.",
            expiryDate: "The expiration date is <br /> typically located on the <br /> front of your card, below <br /> the card number.",
            automaticPaymentDate: "Start date of the monthly automatic charge.",
        },
        successMessages: {
            success: "Success",
            cardRegistered: "Card registered successfully",
            completedForm: "Your payment has been successfully processed. You can close this window.",
            paymentSuccess: "Payment successful",
        },
        errorMessages: {
            error: "Error",
            genericError: "An error occurred, please try again.",
            cardNotRegistered: "Card not registered",
            cardInvalid: "Invalid card",
            linkInvalid: "Invalid link",
            cardNotVerified: "Card could not be verified. Probably does not have sufficient funds",
            cardAlreadyRegistered: "Card already registered",
            paymentFailed: "Payment failed",
        },
        invalidLink: "Invalid link",
        invalidLinkDescription: "The link you are looking for has expired or is no longer available.",
        validLink: "Operation completed successfully",
        validLinkDescription: "The operation has been successfully completed. You can close this window.",
        validLinkDescriptionWithErrors: "The operation has been completed with errors. You can close this window.",
        initialPayment: "Initial payment",
        monthlyPayment: "Monthly payment",
        transactionDeclined: "Transaction declined",
        automaticPayment: "Scheduled payment",
        automaticPaymentAmount: "Amount",
        automaticPaymentDay: "Select payment day",
        amount: "Amount",
        status: "Status",
        service: "Service",
        concept: "Concept",
        datetime: "Date/Time",
        transactionId: "Transaction ID",
        scheduledPaymentDate: "Next payment date",
        monthlyPaymentAmount: "Monthly payment amount",
        date: "Date",
        configureAutomaticPayment: "Schedule automatic payment",
        save: "Save",
        close: "Close",
    },
};
